import { useEffect } from "react"
import { useDataStore } from "./dataStore"

export const DataInitializer = ({ children }) => {
    const fetchData = useDataStore((state) => state.fetchData)

    useEffect(() => {
        fetchData().catch(console.error)
    }, [fetchData])

    return <>{children}</>
}
